import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import GET_MY_WISH_LIST from '../operations/queries/get-my-wish-list.js';
import GET_SHOPPING_LIST_BY_ID from '../operations/queries/get-shopping-list-by-id.js';
import { mapShoppingListToWishlistItems } from '../utils/shopping-list-to-wishlist-mapper.js';
import { useWishlistAuthState } from './use-wishlist-auth-state.js';

/**
 * This hook allows you to get the current wishlist of an user if they have one,
 * it will automatically reconcile the wishlist data whether it is coming from
 * a logged user or an anonymous one.
 */ const useGetWishlist = ()=>{
    var ref7, ref1, ref2, ref3, ref4;
    const { locale  } = useIntl();
    const { isAuthLoading , isUserLoggedIn  } = useWishlistAuthState();
    const { localWishlist , clearWishlist  } = useWishlistId();
    const { data: userWishlistData , loading: userWishlistLoading , error: userWishlistError , refetch: userWishlistRefetch ,  } = useQuery(GET_MY_WISH_LIST, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        skip: isAuthLoading || !isUserLoggedIn
    });
    const { data: anonWishlistData , loading: anonWishlistLoading , error: anonWishlistError , refetch: anonWishlistRefetch ,  } = useQuery(GET_SHOPPING_LIST_BY_ID, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        skip: isAuthLoading || isUserLoggedIn || !localWishlist,
        variables: {
            shoppinglistId: localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id
        },
        onCompleted: (data)=>{
            var ref;
            /*
        There are scenarios where CommerceTools removes a shopping list/wishlist (because of its storage policy/limit),
        but then the local storage still has the wishlist id. To prevent this, we need to filter on a BE failure
        and clear the local storage.
      */ if (((ref = data.shoppinglistById.failure) === null || ref === void 0 ? void 0 : ref.__typename) === 'ShoppinglistNotFoundFailure') {
                clearWishlist();
            }
        }
    });
    /**
   * We call this hook again so we can pass the refetch functions from our graph calls.
   * This will make sure the changes get synced throughout tabs.
   */ useWishlistId(isUserLoggedIn ? userWishlistRefetch : anonWishlistRefetch);
    const isLoading = isAuthLoading || (isUserLoggedIn ? userWishlistLoading : anonWishlistLoading);
    const anonError = anonWishlistError !== null && anonWishlistError !== void 0 ? anonWishlistError : anonWishlistData === null || anonWishlistData === void 0 ? void 0 : anonWishlistData.shoppinglistById.failure;
    const error = isUserLoggedIn ? userWishlistError : anonError;
    var ref5;
    const mappedUserData = (userWishlistData === null || userWishlistData === void 0 ? void 0 : (ref7 = userWishlistData.me) === null || ref7 === void 0 ? void 0 : ref7.wishlist) ? {
        items: mapShoppingListToWishlistItems(userWishlistData === null || userWishlistData === void 0 ? void 0 : (ref1 = userWishlistData.me) === null || ref1 === void 0 ? void 0 : ref1.wishlist),
        id: (ref5 = userWishlistData === null || userWishlistData === void 0 ? void 0 : (ref2 = userWishlistData.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.wishlist) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref5 !== void 0 ? ref5 : ''
    } : null;
    var ref6;
    const mappedAnonData = (anonWishlistData === null || anonWishlistData === void 0 ? void 0 : anonWishlistData.shoppinglistById.shoppinglist) ? {
        items: mapShoppingListToWishlistItems(anonWishlistData === null || anonWishlistData === void 0 ? void 0 : anonWishlistData.shoppinglistById.shoppinglist),
        id: (ref6 = (ref4 = anonWishlistData === null || anonWishlistData === void 0 ? void 0 : anonWishlistData.shoppinglistById.shoppinglist) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref6 !== void 0 ? ref6 : ''
    } : null;
    const data1 = isUserLoggedIn ? mappedUserData : mappedAnonData;
    return {
        data: data1,
        loading: isLoading,
        error: error !== null && error !== void 0 ? error : null
    };
};

export { useGetWishlist };
//# sourceMappingURL=use-get-wishlist.js.map
